import { makeCall, Methods } from "../../utils/makeCall";
import { DayCapacityData } from "./periodCapacityData.entity";
import { GetPeriodCapacityDataErrors } from "./periodCapacityData.error";

export type GetPeriodCapacityDataRequest = {
  begin_date: string; // ISOString
  end_date: string; // ISOString
};
export type GetPeriodCapacityDataResponse = { data: DayCapacityData[] };

export const getPeriodCapacityData = makeCall<
  GetPeriodCapacityDataRequest,
  GetPeriodCapacityDataResponse,
  GetPeriodCapacityDataErrors
>(Methods.GetPeriodCapacityData);
